import { render, staticRenderFns } from "./LockerNumberRegistration.vue?vue&type=template&id=505031ce&"
import script from "./LockerNumberRegistration.vue?vue&type=script&lang=js&"
export * from "./LockerNumberRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports